import React from 'react';
import Container from 'react-bootstrap/Container';
import Accordion from 'react-bootstrap/Accordion';
import { contx } from '../../../App';

// FAQ content from public/support.html (exact same text)
const FAQ_AR = [
  { q: 'ما هو تطبيق تمتم؟', a: 'تطبيق يتيح للمستخدمين شراء المنتجات والخدمات ودفع ثمنها بنظام الأقساط المرنة، مع إمكانية متابعة مشترياتهم وجدولة الدفع بسهولة' },
  { q: 'كيف يعمل نظام التقسيط في تمتم؟', a: 'يمكنك اختيار المنتجات  او الخدمات التي تريدها، ثم تحديد مدة وعدد الأقساط، ويحسب التطبيق قيمة القسط الشهري بشكل تلقائي مع إمكانية الدفع عن طريق طرق متعددة.' },
  { q: 'هل التطبيق متاح لكل المحافظات في العراق؟', a: 'نعم، التطبيق متاح للمستخدمين في أغلب محافظات العراق، ويستمر الفريق بتوسيع التغطية تدريجيًا,ولكن بالمرحلة الاولى في بغداد .' },
  { q: 'هل استخدام التطبيق مجاني؟', a: 'نعم، تحميل التطبيق وإنشاء الحساب مجاني. الرسوم قد تكون فقط عند استخدام خدمات التقسيط أو في حالة الرسوم الإضافية المحددة للمنتجات' },
  { q: 'كيف أنشئ حسابًا في التطبيق؟', a: 'اولا : حمّل التطبيق من متجر Google Play أو App Store.\nثانيا :اختر "تسجيل جديد"، وأدخل البيانات المطلوبة مثل الاسم ورقم الهاتف والبريد الإلكتروني.\nثالثا :أضف طريقة الدفع وأكمل التحقق لإتمام إنشاء الحساب' },
  { q: 'هل يمكنني امتلاك أكثر من حساب؟', a: 'عادة، يُسمح بحساب واحد لكل رقم هاتف أو بريد إلكتروني بدون تشابه اسماء لضمان الأمان وتتبع الأقساط.' },
  { q: 'كيف أتواصل مع خدمة العملاء؟', a: '- البريد الإلكتروني\n- أرقام الهاتف المخصصة للدعم (  07847744444)' },
  { q: 'ما هي أوقات عمل الدعم؟', a: 'عادةً يعمل الدعم خلال ساعات الدوام الرسمي، وغالبًا من 8 صباحًا إلى 3 مساءً و بالامكان ان تكون بعض القنوات الإلكترونية قد تكون متاحة 24 ساعة .' },
];

// FAQ content (English) - exact text you provided
const FAQ_EN = [
  {
    q: 'What is the TamTam application?',
    a: 'An application that allows users to purchase products and services and pay for them through a flexible installment system, with the ability to track their purchases and easily schedule payments.',
  },
  {
    q: 'How does the installment system work in TamTam?',
    a: 'You can choose the products or services you want, then specify the duration and number of installments, and the application automatically calculates the monthly installment amount with the option to pay via multiple methods.',
  },
  {
    q: 'Is the application available for all provinces in Iraq?',
    a: 'Yes, the application is available to users in most provinces of Iraq, and the team continues to gradually expand coverage, but in the first phase, it is in Baghdad.',
  },
  {
    q: 'Is using the application free?',
    a: 'Yes, downloading the app and creating an account is free. Fees may only apply when using installment services or in the case of specific additional charges for products.',
  },
  {
    q: 'How do I create an account in the app?',
    a: 'First: Download the app from the Google Play Store or the App Store.\nSecond: Select "Register New" and enter the required information such as your name, phone number, and email address.\nThird: Add a payment method and complete the verification to finalize account creation.',
  },
  {
    q: 'Can I have more than one account?',
    a: 'Typically, one account is allowed per phone number or email address without similar names to ensure security and track installments.',
  },
  {
    q: 'How do I contact customer service?',
    a: 'Email\nPhone numbers dedicated for support (07847744444)',
  },
  {
    q: 'What are the support hours?',
    a: 'Support usually operates during business hours, often from 8 AM to 3 PM, and some electronic channels may be available 24 hours.',
  },
];

const Support = () => {
  const { lang } = React.useContext(contx);
  const isAr = lang === 'ar';
  const faq = isAr ? FAQ_AR : FAQ_EN;

  const title = isAr ? 'الأسئلة الشائعة' : 'Frequently Asked Questions';
  const subtitle = isAr
    ? 'نحن هنا لمساعدتك. هذه إجابات لأكثر الأسئلة التي قد تخطر ببالك عند استخدام التطبيق.'
    : 'We are here to help you. These are answers to the most common questions you may have when using the app.';

  return (
    <div style={{ width: '100%', minHeight: '60vh' }} dir={isAr ? 'rtl' : 'ltr'}>
      <Container className="py-5">
        <h1 style={{ color: '#005247', marginBottom: '0.5rem', textAlign: 'center' }}>{title}</h1>
        <p style={{ fontSize: '1.1rem', color: '#666', textAlign: 'center', marginBottom: '2rem' }}>{subtitle}</p>

        <Accordion defaultActiveKey="0" className="faq-accordion">
          {faq.map((item, index) => (
            <Accordion.Item key={index} eventKey={String(index)} style={{ marginBottom: '0.75rem', borderRadius: '12px', overflow: 'hidden', border: '1px solid #edebeb', backgroundColor: '#f6f6f6' }}>
              <Accordion.Header style={{ fontWeight: 500, fontSize: '1.1rem', color: '#424242' }}>
                {item.q}
              </Accordion.Header>
              <Accordion.Body style={{ color: '#8c8c8c', fontSize: '1rem', lineHeight: 1.5, whiteSpace: 'pre-line' }}>
                {item.a}
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </Container>
    </div>
  );
};

export default Support;
